import sendGAEvent from "./sendGAEvent";
import { GAEventAction, GAEventCategory, GAEventLabel } from "../../constants";

export const sendGAItemCheck = () => {
    sendGAEvent({
        event_category: GAEventCategory.CHECKLIST_ACTIONS,
        event_action: GAEventAction.ITEM_CHECKBOX_CLICK,
        event_label: GAEventLabel.ITEM_CHECK
    });
}

export const sendGAItemUncheck = () => {
    sendGAEvent({
        event_category: GAEventCategory.CHECKLIST_ACTIONS,
        event_action: GAEventAction.ITEM_CHECKBOX_CLICK,
        event_label: GAEventLabel.ITEM_UNCHECK
    });
}

export const sendGASublistLinkClick = () => {
    sendGAEvent({
        event_category: GAEventCategory.CHECKLIST_ACTIONS,
        event_action: GAEventAction.SUBLIST_LINK_CLICK,
        event_label: GAEventLabel.SUBLIST_LINK
    });
}

export const sendGAItemLinkClick = () => {
    sendGAEvent({
        event_category: GAEventCategory.CHECKLIST_ACTIONS,
        event_action: GAEventAction.ITEM_LINK_CLICK,
        event_label: GAEventLabel.ITEM_LINK
    });
}

export const sendGAIkeaFamilyClick = () => {
    sendGAEvent({
        event_category: GAEventCategory.CHECKLIST_ACTIONS,
        event_action: GAEventAction.IKEA_FAMILY_SIGN_UP_CLICK,
        event_label: GAEventLabel.IKEA_FAMILY_SIGN_UP
    });
}

export const sendGADownloadPDFClick = () => {
    sendGAEvent({
        event_category: GAEventCategory.CHECKLIST_ACTIONS,
        event_action: GAEventAction.PDF_DOWNLOAD_CLICK,
        event_label: GAEventLabel.PDF_DOWNLOAD
    });
}
